import { lazy } from "react";

const CreatePromotionPage = lazy(() => import("./create"));
const PromotionListPage = lazy(() => import("./main"));
const UpdatePromotionPage = lazy(() => import("./update"));

export {
  CreatePromotionPage, PromotionListPage, UpdatePromotionPage,
};
